import React from 'react'
import { DestinationType } from '../../dataTypes'

type DestinationItemProps = {
    destination : DestinationType
    onItemClick : () => void
}

// IF DESTINATION == ALL I DONT SHOW IT!!

const DestinationItem = ({destination, onItemClick}: DestinationItemProps) => {
  return (
      destination.destination != 'All' ? <div onClick={onItemClick}>{ destination.destination }</div> : null
  )
}

export default DestinationItem